export enum WorkRequestStatusId {
	Unknown = -3,
	Deleted = -2,
	Rejected = -1,
	Requested = 0,
	Accepted = 1,
	Scheduled = 2,
	InProgress = 3,
	Finished = 4,
}

export const WorkRequestStatusIdNameMap = [
	{ id: WorkRequestStatusId.Deleted, name: 'Törölve' },
	{ id: WorkRequestStatusId.Rejected, name: 'Visszautasítva' },
	{ id: WorkRequestStatusId.Requested, name: 'Bejelentve' },
	{ id: WorkRequestStatusId.Accepted, name: 'Elfogadva' },
	{ id: WorkRequestStatusId.Scheduled, name: 'Ütemezve' },
	{ id: WorkRequestStatusId.InProgress, name: 'Folyamatban' },
	{ id: WorkRequestStatusId.Finished, name: 'Befejezve' },
];

export enum WorkRequestRole {
	NoRight = 0,
	User = 1,
	Controller = 2
}

export type WorkRequest = {
	id: number,
	tenantId: number,
	timeStamp: string | number | Date,
	customerId: number,
	requestorId: number,
	createdDate: string | number | Date,
	earliestStartDate: string | number | Date | null,
	latestEndDate: string | number | Date | null,
	preferedWorkerName: string,
	subject: string,
	description: string,
	statusId: number,
	rejectionReason: string,
	tenantName: string,
	requestorName: string,
	customerName: string,
	status: string, //	status: TaskStatus,
	role: WorkRequestRole
};

export const newWorkRequest: WorkRequest = {
	id: -1,
	tenantId: 0,
	timeStamp: 0,
	customerId: 0,
	requestorId: 0,
	createdDate: null,
	earliestStartDate: null,
	latestEndDate: null,
	preferedWorkerName: "",
	subject: "",
	description: "",
	statusId: 0,
	rejectionReason: "",
	tenantName: "",
	requestorName: "",
	customerName: "",
	status: "", //	status: TaskStatus,
	role: 1
};




export const taskPriorityList: string[] = [
  'Low',
  'Normal',
  'High',
];

export type TaskPriority = (typeof taskPriorityList)[number];

